import { z } from "zod";

/**
 * One cross-resource search hit (`globalSearch.search`). `type` mirrors the
 * `GlobalSearchResultType` union; `detail` is type-specific display context
 * (e.g. a training job's status). All fields are flat strings — no dates,
 * numbers-as-strings, or nested shapes.
 */
export const globalSearchResultSchema = z.object({
  type: z.enum(["agent", "deployment", "dataset", "rubric", "trainingJob"]),
  id: z.string(),
  name: z.string(),
  projectId: z.string().nullable(),
  projectName: z.string().nullable(),
  detail: z.string().nullable(),
});
